module.exports = __webpack_public_path__ + "static/img/platinum 1.b92ebbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/platinum 1.png
// module id = pZD6
// module chunks = 35